import React, { useRef, useState, useEffect } from "react";
import { Tooltip } from "antd";
import ClickOutside from "components/OnClickOutside";
import styled from "styled-components";
import BottomDropDown from "utils/assets/images/resource-dropdown.svg";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const CategoryMenu = styled.div`
  background-color: #0b1c2b;
  border-radius: 30px;
  color: #fff;
  // width: 201px;
  height: 42px;
  // margin-top: 20px;
  display: flex;
  align-items: center;
  // justify-content: center;
  // text-align: center;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 1px solid #2784a3;
  color: #fff;
  padding-left: 15px;
  padding-right: 15px;

  @media screen and (max-width: 768px) {
    // width: 100% !important;
    height: 36px;
    color: #fff;
    text-align: center;
    font-family: Avenir;
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  }
`;

const AncotasDropDown = ({
  data,
  open,
  dropDownHandler,
  anecotasThemeFilter,
  closeDropDown,
  handleDropdownClick,
  isResizingWindow,
  typeOf,
}) => {
  return (
    <DropdownForLaptopAncotas
      open={open}
      anecotasThemeFilter={anecotasThemeFilter}
      closeDropDown={closeDropDown}
      dropDownHandler={dropDownHandler}
      data={data}
      handleDropdownClick={handleDropdownClick}
      isResizingWindow={isResizingWindow}
      typeOf={typeOf}
    />
  );
};

const DropdownForLaptopAncotas = ({
  dropDownHandler,
  data,
  anecotasThemeFilter,
  closeDropDown,
  handleDropdownClick,
  open,
  isResizingWindow,
  typeOf
}) => {
  const ref = useRef();
  const [expanded, setExpanded] = useState({"panel1": true, "panel2": false, "panel3": false, "panel4": false, "panel5": false, "panel6": false});
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(prev => ({ ...prev, [panel]: isExpanded }));
  };

  const renderSection = (title, dataSource, titleProperty, panelIndex) => {
    const itemsPerColumn = Array.isArray(dataSource) ? Math.ceil(dataSource.length / 2) : 3;
    return (
    <div className="anectodasAccordian">
     <Accordion expanded={expanded[`panel${panelIndex}`] === true} onChange={handleChange(`panel${panelIndex}`)}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${panelIndex}bh-content`}
                id={`panel${panelIndex}bh-header`}
              >      
      <div className="w-full text-center border-b-white mi-17px anctodas-theme-dropdown-heading pt-24px pb-13px">
        {title}
      </div>
      </AccordionSummary>
      <AccordionDetails>
      <div className="d-grid place-items-start grid-2-column">
        {[0, 1]?.map((columnIndex) => (
          <div key={`column-${columnIndex}`} className="w-full">
            {Array.isArray(dataSource) && dataSource
              .slice(columnIndex * itemsPerColumn, (columnIndex + 1) * itemsPerColumn)
              .map((ct, index) => (
                <div
                  onClick={() =>
                    dropDownHandler("anecotasThemeFilter", ct[titleProperty])
                  }
                  key={`${title}-${columnIndex}-${index}`}
                  className="border-b-13314C"
                >
                  <div
                    className={`anctodas-theme-dropdown-label gap-10px flex items-center pt-15px pb-15px ${
                      columnIndex === 0 ? "pi-17px" : ""
                    }`}
                  >

                    <Tooltip title={ct[titleProperty]} placement="top" trigger="hover" className="anectodasThemeTooltip">
                      <div>
                    <input
                      className="w-16px-h-16px"
                      type="checkbox"
                      checked={anecotasThemeFilter?.includes(ct[titleProperty])}
                    />
                    <span className="whitespace-nowrap dropdown-list-name-ap-theme">
                    {ct[titleProperty].length > windowWidth >= 1200 ? 21 : 18
                      ? ct[titleProperty].slice(0, windowWidth >= 1200 ? 21 : 18) + "..."
                      : ct[titleProperty]}
                </span>
                </div>
                </Tooltip>
                  </div>
                </div>
              ))}
          </div>
        ))}
      </div>
      </AccordionDetails>
      </Accordion>
    </div>
  );
  };
  const createLabelDiv = (titles) => (
    <div className="flex-1" disabled={true}>
      <div className="pl-34px grid-3-template bg-column-gap-45px">
        {Array.isArray(titles) && titles.map((title, index) => (
          <div
            key={index}
            style={{ paddingLeft: 0 }}
            className="w-250px ap-spanish-label border-b-lightGrey p-18px"
          >
            {title}
          </div>
        ))}
      </div>
    </div>
  );

  const createThemeItem = (ct) => (
    <div
      className="ib-theme-button grid-3-template  border-for-inner"
      style={{ padding: 0, height: "60px" }}
    >
      {["", "2", "3"].map((suffix, i) => {
        const title = ct[`title${suffix}`];
        const icon = ct[`icon`];
        return (
          <Tooltip key={i} placement="top" title={title}>
            <div
              onClick={() => dropDownHandler("anecotasThemeFilter", title)}
              className={`${
                i === 0 ? "pl-34px" : ""
              } dropdown-menus-item cursor-pointer h-full d-flex items-center w-fit-content`}
              style={{
                paddingLeft: i !== 0 ? "20px" : undefined,
                marginLeft: i !== 0 ? "20px" : undefined,
              }}
            >
              <input
                className="w-16px-h-16px"
                type="checkbox"
                checked={anecotasThemeFilter?.includes(title)}
              />
              <img
                src={icon}
                loading="lazy"
                className="image-dropdown-ancodtas"
                alt=""
              />
              <div className="ellipse dropdown-list-name-ap-theme">{title}</div>
            </div>
          </Tooltip>
        );
      })}
    </div>
  );

  return (
    <>
      <CategoryMenu
        ref={ref}
        style={{
          paddingRight: "0px",
          paddingLeft: "0px",
          border: "1px solid #ffffff",
          position: "relative",
          cursor: "pointer",
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleDropdownClick("ANéCDOTAS THEMES");
        }}
        className="md-w-full-2 box-shadow-resource-hover w-247px lg-w-231px box-shadow-resource-hover  arrow-contanier-resoruce  h-43px lg-h-36px  searchIconMob"
      >
        <Tooltip
          title={anecotasThemeFilter?.join(", ").toString()}
          placement="top"
        >
          <span className="dropdown-text lg-pl-17px pl-16px lg-pr-4px">
            {anecotasThemeFilter &&
            anecotasThemeFilter?.length > 0 &&
            anecotasThemeFilter !== ""
              ? anecotasThemeFilter.join(",").length > 20
                ? anecotasThemeFilter?.join(",").slice(0, 10) + "..."
                : anecotasThemeFilter
              : "TEXTBOOK UNITS"}
          </span>
        </Tooltip>

        {/* <MenuIconImg src={MenuIcon} />{" "} */}
        <div className="dropdown-resource-arrow-container themeSearchIconMob">
          <div
            style={{
              transition: "transform 0.4s ease-in-out",
              transform: open ? "rotate(-180deg)" : "rotate(0deg)",
            }}
          >
            <img src={BottomDropDown} alt="" />
          </div>
        </div>
      </CategoryMenu>
      {open && (
        <>
          {/* mobile dropdown */}
            <ClickOutside
              onClickOutside={closeDropDown}
              className=" lg-d-block bg-dropdown-for-resource box-shadow-dropdown-resource border-radius-14px absolute z-index-990 overflow-auto max-height-600px anectodadAccordianWidth "
            >
                  {renderSection("Anécdotas Inicial 1", data?.first_phase, "title", 1)}
              
              {renderSection(
                "Anécdotas Inicial 2",
                data?.first_phase,
                "title2", 2
              )}
              {renderSection(
                "Anécdotas Inicial 3",
                data?.first_phase,
                "title3", 3
              )}
              {renderSection("Anécdotas 1", data?.second_phase, "title", 4)}
              {renderSection("Anécdotas 2", data?.second_phase, "title2", 5)}
              {renderSection("América Ed. 4", data?.second_phase, "title3", 6)}
              {renderSection("Las ventanas del mundo 1", data?.third_phase, "title", 7)}
              {renderSection("Las ventanas del mundo 2", data?.third_phase, "title2", 8)}
              {renderSection("Las ventanas del mundo 3", data?.third_phase, "title3", 9)}
            </ClickOutside>
            
          {/* laptop dropdown */}
          {/* {isResizingWindow >= 1300 && (
            <ClickOutside
              onClickOutside={closeDropDown}
              // className="lg-d-none anoct-dropdown bg-dropdown-for-resource top-59px  box-shadow-dropdown-resource border-radius-14px absolute z-index-990"
              className={`lg-d-none ${
                typeOf === "story" ? "allStoryDropSection" : ""
              } anoct-dropdown bg-dropdown-for-resource top-59px box-shadow-dropdown-resource border-radius-14px absolute z-index-990`}
            >
              {" "}
              
              {createLabelDiv([
                "Anécdotas Inicial 1",
                "Anécdotas Inicial 2",
                "Anécdotas Inicial 3",
              ])}
              {data?.first_phase?.map(createThemeItem)}
              {createLabelDiv(["Anécdotas 1", "Anécdotas 2", "América Ed. 4"])}
              {data?.second_phase?.map(createThemeItem)}
              {createLabelDiv(["Las ventanas del mundo 1", "Las ventanas del mundo 2", "Las ventanas del mundo 3"])}
              {data?.third_phase?.map(createThemeItem)}
            </ClickOutside>
          )} */}
        </>
      )}
    </>
  );
};

export default AncotasDropDown;
